import script from "./Calendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Calendar.vue?vue&type=script&setup=true&lang=ts"

import "./Calendar.vue?vue&type=style&index=0&id=6735d461&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6735d461"]])

export default __exports__